export const formatReportActivityAnalyzeTitleUnit = (title: string) => {
  return `${title} (min)`;
};

export const formatReportActivityAnalyzeValueUnit = (
  value?: string | number,
) => {
  return `${value} min`;
};
